import React from 'react';
import { Flex, Heading, Button } from 'rebass';
import styled from 'styled-components';
import Link from 'components/Link';
import { RECRUITER, EMPLOYER } from 'constants/index';
import { UserRoleType } from 'types/global';
import { LACKOFJOBPOSTS } from '../content';

const InfoWrapper = styled(Flex)`
  max-width: 560px;
  text-align: center;
  line-height: 1.5;
`;

interface LackOfJobPostsProps {
  userRole: UserRoleType;
}

const LackOfJobPosts: React.FC<LackOfJobPostsProps> = (props): JSX.Element => {
  const { userRole } = props;
  return (
    <Flex width="100%" justifyContent="center" pt={20}>
      <InfoWrapper flexDirection="column" alignItems="center">
        <Heading fontSize={['36px']} fontWeight={6} mb={3}>
          {userRole === RECRUITER && LACKOFJOBPOSTS.recruiter.heading}
          {userRole === EMPLOYER && LACKOFJOBPOSTS.employer.heading}
        </Heading>
        {userRole === RECRUITER && (
          <Link to="/job-posts/all">
            <Button variant="primary">{LACKOFJOBPOSTS.recruiter.button}</Button>
          </Link>
        )}
        {userRole === EMPLOYER && (
          <Link to="/create-job-post">
            <Button variant="primary">{LACKOFJOBPOSTS.employer.button}</Button>
          </Link>
        )}
      </InfoWrapper>
    </Flex>
  );
};

export default LackOfJobPosts;
